/**
 * HS코드는 숫자만 쓴다 — 서버 `server/src/lib/schemas.ts` 의 hsCodeField 와 같은 규칙이다.
 * 규칙을 고치면 양쪽을 함께 고칠 것.
 *
 * 사람은 `6110.30` 으로 적고 세관에 내는 값은 `611030` 이다. 손으로 치든 붙여넣든
 * 점을 지워 숫자만 남긴다.
 */

/** DB 컬럼과 서버 스키마가 20자까지 받는다. */
export const HS_CODE_MAX_DIGITS = 20

/** 저장·전송용 모양 — 숫자만. */
export function hsCodeDigits(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, HS_CODE_MAX_DIGITS)
}
